import { render, staticRenderFns } from "./DefaultViewer.vue?vue&type=template&id=2f43842b&"
import script from "./DefaultViewer.vue?vue&type=script&lang=js&"
export * from "./DefaultViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports